export default "__VITE_ASSET__Ba295iA$__"